/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    AddCover: {
        id: 'cep.components.SgCepMotorAddons.AddCover',
        defaultMessage: 'Add'
    },
    RemoveCover: {
        id: 'cep.components.SgCepMotorAddons.RemoveCover',
        defaultMessage: 'Remove'
    },
    Included: {
        id: 'cep.components.SgCepMotorAddons.Included',
        defaultMessage: 'Included'
    },
    CoverLevelText: {
        id: 'cep.components.SgCepMotorAddons.CoverLevel',
        defaultMessage: 'Your cover level is {coverLevel}'
    },
    LegalName: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.legal.Name',
        defaultMessage: 'Motor Legal Protection'
    },
    LegalDescription: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.legal.Description',
        defaultMessage: 'Will cover you for up to £100,000 of legal costs to recover uninsured losses following a motoring incident that wasn\'t your fault, as long as an independent legal representative believes they can win your case.'
    },
    KeyName: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.key.Name',
        defaultMessage: 'Key Protection'
    },
    KeyDescription: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.key.Description',
        defaultMessage: 'Will cover up to £2,500 per claim and, with us, you even get up to £250 for wear and tear. You won\'t have to pay an excess, your NCD won\'t be affected, and we cover claims up to 60 days after the insured incident. This is included as standard on Saga Plus.'
    },
    VolExcessName: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.VolExcess.Name',
        defaultMessage: ' Voluntary Accidental Damage Excess'
    },
    VolExcessDescription: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.VolExcess.Description',
        defaultMessage: 'Choosing a higher voluntary excess may lower your premium. Your voluntary excess will be applied on top of any compulsory excess in the event of a claim.'
    },
    PersonalAccidentName: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.pa.Name',
        defaultMessage: 'Increased Personal Accident'
    },
    PersonalAccidentDescription: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.pa.Description',
        defaultMessage: 'You can claim up to £150,000 per person for you and your family members if any of you are seriously injured in an accident involving your {vehicle}. It also provides a daily cash sum for overnight hospital stays up to 180 nights, and less serious injuries are covered too, such as broken bones. Cover extends the amount paid and the range of injuries covered.'
    },
    ReplacementCarName: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.replacementCar.Name',
        defaultMessage: 'Replacement car extension for Theft and Total Loss'
    },
    ReplacementCarDescription: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.replacementCar.Description',
        defaultMessage: 'A guaranteed replacement car by the end of the next working day if yours is stolen or written off anywhere in the UK. You can also keep the car for an extra 7 days after the settlement is paid and receive £100 cash benefit when you claim.'
    },
    BreakdownName: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.breakdown.Name',
        defaultMessage: 'Saga Breakdown Assistance'
    },
    BreakdownDescription: {
        id: 'cep.components.endorsement.sgEndorsementCoveragesPage.addons.breakdown.Description',
        defaultMessage: 'There are five levels of breakdown assistance available, please select the Add button and choose the level you want'
    },
});
